<template>
    <div>
        <div
            v-if="loading"
            class="percent-badge is-loading"
        >
            <span
                v-loading="true"
                element-loading-spinner="el-icon-loading"
            ></span>
        </div>
        <div
            v-else-if="displayPercent"
            class="percent-badge"
        >{{ entity === 'site' ? sitePercent : percent }}%</div>
    </div>
</template>

<script>
    export default {
        name: 'ConsumptionPercentBadge',
        props:{
            uid:{
                type: String,
                required: true
            },
            entity:{
                type: String,
                required: true
            },        
        },
        data(){
            return {
                loading: false,
                percent: null,
            }
        },
        computed:{
            model(){
                switch (this.entity) {
                    case 'area':
                        return 'area-simulation-result';
                    case 'equipment':
                        return 'equipment-simulation-result';
                    default:
                        return 'site-simulation-result';
                }
            },
            uidFilter(){
                switch (this.entity) {
                    case 'area':
                        return 'area_uid';
                    case 'equipment':
                        return 'equipment_uid';
                    default:
                        return 'site_uid';
                }
            },
            sitePercent(){
                return 100;
            },
            currentSimulation() {
                return this.$store.getters.currentSimulation !== null ;
            },
            displayPercent(){
                if(this.entity === 'site'){
                    return this.currentSimulation;
                }
                return this.percent !== null && this.percent !== undefined && this.currentSimulation;
            }
        },
        mounted(){
            if(!this.$store.getters.currentSimulation){
                this.loading = false;
                return;
            }
            this.getConsumptionPercent();
        },
        methods:{
            formatedValue(value){
                if(value === null || value === undefined){
                    return null;
                }
                return Math.round((value * 100).toFixed(2));
            },
            getConsumptionPercent(mounted=false){
                this.loading = true;
                let url = `${window.config.api_root_url}/${this.model}/?${this.uidFilter}=${this.uid}&is_latest=true&archived=false`;
                this.$store.dispatch('fetchTotalSiteConsumptionPercent', {url: url}).then(data =>{
                    this.loading = false;
                    this.percent = this.formatedValue(data);
                }).catch(err => {
                    this.loading = false;
                    console.error(err);
                })
            }
        }
    }
</script>

<style lang="scss">
.percent-badge {
    background-color: rgb(65, 64, 64);
    color: white;
    padding: 0.2em 0.5em;
    border-radius: 0.2em;
    font-weight: bold;
    min-height: 26.5px;
    min-width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-loading-parent--relative {
        .el-loading-mask{
            background-color: rgba(255, 255, 255, 0) !important;
            position: unset !important;
            .el-loading-spinner{
                position: unset !important;
                margin-top: 0 !important;
                .el-icon-loading{
                    color: white !important;
                }
            }
        }
    }
    &.is-loading{
        background-color: rgba(65, 64, 64, 0.5);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/partials/ui/ConsumptionPercentBadge.vue